import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-user-exists-invite'
})
export class Ng1UserExistsInviteDirective extends UpgradeComponent {
  @Input() user;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersInviteExist', elementRef, injector);
  }
}
